import { rootApi } from '../rootApi';

export const bulletinImplementationReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getBulletinImplementationReport: builder.query({
            query: (body = {}) => ({
                url: 'v1/bulletinimplementationreport/getlist',
                method: 'POST',
                body: {
                    pageSize: body?.pageSize ?? 20,
                    pageNumber: body?.pageNumber ?? 1,
                    filters: body?.filters ?? [],
                    sorts: body?.sorts ?? [],
                    includeFilterOptions: body?.includeFilterOptions ?? false,
                    filterOptionsColumns: body?.filterOptionsColumns ?? []
                }
            }),
            transformResponse: (response) => ({ items: Array.isArray(response?.data?.items) ? response.data.items : [], totalCount: response?.data?.totalCount ?? 0 }),
            providesTags: ['BulletinImplementationReport']
        }),
        exportBulletinImplementationReportToExcel: builder.query({
            query: (body = {}) => ({
                url: 'v1/bulletinimplementationreport/exporttoexcel',
                method: 'POST',
                body: { filters: body?.filters ?? null, sorts: body?.sorts ?? null, compressionType: 0 }
            }),
            transformResponse: (response) => response?.data ?? { fileBase64: null, error: true }
        })
    }),
    overrideExisting: false
});

export const { useGetBulletinImplementationReportQuery, useLazyExportBulletinImplementationReportToExcelQuery } = bulletinImplementationReportApi;
